import { useMobileClassNameEffect } from '../effects/adaptive-effects';

import Typography from '@mui/material/Typography';
import type { TypographyProps } from '@mui/material/Typography/Typography';
import { TYPOGRAPHY_COLORS } from '../constants/colors';

import './uni-credit-typography.scss';
import './uni-credit-typography-mobile.scss';

export type UniCreditColors = `${TYPOGRAPHY_COLORS}`;

export type UniCreditTypographyProps = {
  type:
  'h1-bold' |
  'h2-bold' |
  'h3-bold' |
  'h4-medium' |
  'caption-medium' |
  'body' |
  'text-snack' |
  'text-button-bold-uppercase' |
  'text-16-regular' |
  'text-16-medium' |
  'text-14-regular',
  color?: UniCreditColors,
  children: React.ReactNode,
  disabled?: boolean,
} & Omit<TypographyProps, 'color'>;

function UniCreditTypography({
  color,
  type,
  variant,
  children,
  disabled,
  className,
  ...props
}: UniCreditTypographyProps) {
  const mobileClassName = useMobileClassNameEffect();

  const typographyVariant: { [key in UniCreditTypographyProps['type']]: TypographyProps['variant'] } = {
    'h1-bold': 'h1',
    'h2-bold': 'h2',
    'h3-bold': 'h3',
    'h4-medium': 'h4',
    'caption-medium': 'h5',
    'body': 'body1',
    'text-snack': 'body1',
    'text-button-bold-uppercase': 'body1',
    'text-16-regular': 'body1',
    'text-14-regular': 'body1',
    'text-16-medium': 'body1',
  };

  return (
    <Typography
      className={`${className || ''} uni-credit-typography-${type} ${mobileClassName}`}
      variant={typographyVariant[type]}
      {...props}
      sx={{
        ...(color && { color: `var(--uni-credit-color-${disabled ? 'k3' : color})` }),
        ...props.sx,
      }}
    >
      {children}
    </Typography>
  );
}

export default UniCreditTypography;
